module.exports = __webpack_public_path__ + "static/media/3_of_diamonds.905ea950.png";